import baseReducer from "../../base/store/reducer";
import constants from "./constants";

export default (state, action) => {
    return baseReducer(state, action, constants);
}